export const GA4_EVENTS = {
  FORM_START: 'form_start',
  ADD_TO_CART: 'add_to_cart',
  VIEW_ITEM: 'view_item',
  VIEW_ITEM_LIST: 'view_item_list',
  SITE_CLICK_TRACKING: 'site_click_tracking',
  PAGE_VIEW: 'page_view',
  SITE_NAVIGATION_CLICKS: 'site_navigation_clicks',
  HTTP_404_ERROR: 'http_404_error',
  CLIENT_SIDE_ERROR: 'client_side_error',
  BEGIN_CHECKOUT: 'begin_checkout',
  ADD_PAYMENT_INFO: 'add_payment_info',
};
export const paymentErrors = {
  INVALID_CREDIT_CARD: 'INVALID_CREDIT_CARD',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_DECLINED: 'PAYMENT_DECLINED',
  ENCRYPTION_FAILED: 'ENCRYPTION_FAILED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
};
export const RECOMMENDED = 'Recommended';
